<template>
  <section class="p-2">
    <loading :active="loader" :opacity="0.9" color="#ff6b00" />
    <v-card-title class="d-block">
      <v-row class="d-flex justify-space-between">
        <v-col lg="6" sm="12">
          <v-form v-model="valid" ref="bulkUpload" class="">
            <v-row no-gutters class="pt-6">
              <v-col cols="12" lg="6" xs="12">
                <v-autocomplete
                  clearable
                  multiple
                  class="rounded mx-2"
                  outlined
                  dense
                  placeholder=""
                  v-model="selectedData"
                  :items="Options"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" lg="5" class="pe-2">
                <v-file-input
                  v-model="document"
                  chips
                  prepend-icon=""
                  :rules="[(v) => !!v || 'Please Upload File']"
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  ref="file"
                  outlined
                  dense
                  label="Upload File"
                  placeholder="No File Choosen"
                  :persistent-placeholder="true"
                  clearable
                >
                  <template v-slot:append>
                    <v-icon
                      v-if="showChoosefile"
                      color="primary"
                      class="mb-2"
                      @click="open"
                    >
                      mdi-cloud-upload
                    </v-icon>
                  </template>
                </v-file-input>
              </v-col>

              <v-col col="12" lg="6" class="mt-1 ms-2">
                <v-btn
                  depressed
                  small
                  color="primary"
                  @click="getFileResults()"
                >
                  Upload
                </v-btn>
                <a href="/MOHA.xlsx" download class="ms-2 samplefile">
                  <v-icon color="primary">mdi-file-excel</v-icon>sample Excel
                  File</a
                >
              </v-col>
            </v-row>
          </v-form>
        </v-col>

        <v-col lg="6" sm="12">
          <v-row class="amountsection main-row" no-gutters>
            <v-col class="mt-4 mb-2">
              <div class="d-flex">
                <div
                  class="ms-3 text-center subtitleFontsize"
                  width="100px"
                  elevation="6"
                >
                  Results
                </div>
              </div>
              <v-card elevation="4"
                ><div class="mt-1 p-0">
                  <v-simple-table dense>
                    <template v-slot:default>
                      <tbody>
                        <tr>
                          <td class="text-left">success</td>
                          <td class="text-left">
                            <a
                              class="text-h5 a_text"
                              @click="getSuccessList()"
                              >{{ success || 0 }}</a
                            >
                          </td>
                        </tr>
                        <tr>
                          <td class="text-left">Failure</td>
                          <td class="text-left">
                            <a
                              class="text-h5 failure_text"
                              @click="getSuccessList()"
                              >{{ failure || 0 }}</a
                            >
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </div>
              </v-card>
            </v-col>
          </v-row></v-col
        >
      </v-row>
    </v-card-title>
    <v-card-title class="pt-0 mt-0">
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-btn depressed @click="downloadExcelsheet" color="primary" small
        ><v-icon small>mdi-file-excel-outline</v-icon>Export
      </v-btn>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        placeholder="Search"
        dense
        class="rounded ml-3"
        hide-details
      ></v-text-field
    ></v-card-title>
    <v-data-table
      fixed-header
      height="55vh"
      :headers="headers"
      :items-per-page="10"
      :items="succesFial"
      no-data-text="Please select the criteria to view records"
      :search="search"
      loading-text="Loading... Please wait"
    >
    </v-data-table>
    <OverlayPageVue :showOverlay="loaderOverlay" />
  </section>
</template>

<script>
import setupService from "@/services/SetupService/setupService.js";
import OverlayPageVue from "@/utils/OverlayPage.vue";
import alerts from "@/mixins/alerts";
export default {
  name: "Sanction List Upload",
  mixins: [alerts],
  data() {
    return {
      document: null,
      loaderOverlay: false,
      // file: excelFile,
      valid: true,
      search: "",
      success: null,
      failure: null,
      uploadid: null,
      showChoosefile: true,
      instructDialog: false,
      results: {
        document_id: 0,
        failure: 0,
        success: 0,
        total_records: 0,
      },
      loader: false,
      selectedData: "MOHA",
      Options: ["MOHA"],
      headers: [
        {
          text: "SDN No",
          value: "customer_id",
        },
        {
          text: "Name",
          value: "name",
        },
        {
          text: "Address",
          value: "phone_number",
        },
        {
          text: "Remarks",
          value: "id_type",
        },
        {
          text: "Source",
          value: "id_number",
        },
        // {
        //   text: "Email",
        //   value: "email",
        // },
      ],
      succesFial: [],
    };
  },

  mounted() {},
  components: {
    OverlayPageVue,
  },

  computed: {},
  methods: {
    stoploader() {
      setTimeout(() => {
        this.loaderOverlay = false;
      }, 400);
    },
    async downloadExcelsheet() {
      if (this.succesFial) {
        this.exportToExcel(this.headers, this.succesFial, "Sanction_list");
      }
    },
    open() {
      this.$refs.file.$el.querySelector("input").click();
    },

    async getFileResults() {
      const validate = this.$refs.bulkUpload.validate();
      if (validate) {
        this.loaderOverlay = true;
        const document = new FormData();
        document.append("document", this.document);
        try {
          const responseData = await setupService.uploadFiles(document);
          if (responseData && responseData.data.status_code === 200) {
            this.stoploader();
            this.showAlertSuccess(responseData.data.message);
            // this.success = responseData.data.data[0].no_of_success;
            // this.failure = responseData.data.data[0].no_of_failure;
            // this.uploadid = responseData.data.data[0].id;
          }
          // else if (responseData.data.status_code == 401) {
          //   this.returnNewToken();
          //   this.getFileResults();
          // }
          else {
            this.showAlertError(responseData.data.message);
            this.stoploader();
          }
        } catch (error) {
          console.log(error.response);
          this.showAlertError("Something went wrong please try again later.");
        }
      }
    },
    async getSuccessList() {
      this.loaderOverlay = true;
      try {
        const response = await setupService.getSuccess(this.uploadid);
        if (response.data.status_code === 200) {
          this.succesFial = response.data.data;
          this.stoploader();
        }
        //  else if (response.data.status_code === 401) {
        //   this.succesFial = [];
        //   this.returnNewToken();
        //   this.getSuccessList();
        //   this.stoploader();
        // }
        else {
          this.succesFial == [];
          this.stoploader();
        }
      } catch (error) {
        this.succesFial = [];
        this.stoploader();
        console.error(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/global.scss";

.custome-profile {
  background-color: #f3f3f3;
}
.btn_active {
  background-color: $primary !important;
  box-shadow: rgba(0, 0, 0, 0.12) 0px 8px 20px, rgba(0, 0, 0, 0.13) 0px 6px 6px !important;
}
.border {
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px !important;
}
.v-text-field__details {
  display: none !important;
}
.v-sheet--offset {
  top: -14px;
  width: 250px;
  height: 30px;
  position: relative;
  border-radius: 5px;
  background-color: rgb(233, 227, 227) !important;
}
.v-sheet--offset1 {
  top: -20px;
  position: relative;
  border-radius: 10px;
  background-color: rgb(131, 24, 24) !important;
}
.a_text {
  color: green;
}
.a_text:hover {
  border-bottom: 1px solid green;
}
.failure_text {
  color: red;
}
.failure_text:hover {
  border-bottom: 1px solid red;
}
.instruction {
  font-size: 12px;
}
.samplefile {
  font-size: 12px;
  text-decoration: none;
}
// .samplefile:hover{
//     border-bottom: 2px solid $primary;
// }
</style>
